<template>
    <div>
        <h3>{{doc_type}}</h3>

        <div class="mb-5" >
            <div v-if="downloadLink">
                <p>Download the {{doc_type}} below by clicking on 'Download {{doc_type}}'.</p>

                <b-button size="lg" variant="primary" :href="downloadLink"><font-awesome-icon icon="file" class="mr-3"></font-awesome-icon>Download {{doc_type}}</b-button>
            </div>
            <div v-else>
                <div v-if="attempts <= 10">
                    <p><b-spinner small></b-spinner>&nbsp; Your {{doc_type}} has been requested.  This process may take a few minutes.  Please wait. ({{attempts}})</p>

                    <b-button size="lg" variant="primary" :disabled="!downloadLink">
                        <font-awesome-icon icon="file" class="mr-3"></font-awesome-icon>Download {{doc_type}}
                    </b-button>
                </div>
                <div v-else>
                    <p><font-awesome-icon icon="ban" class="mr-2"/>The {{doc_type}} failed to generate.  Please try again or contact us for assistance.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import config from '@/config/config.js';

    export default {
        name: 'Certificate',
        components: {},
        props: ['type','hash'],
        data: function() {
            return {
                attempts: 0,
                downloadLink: null
            }
        },
        methods: {
            checkCert() {
                if (this.attempts++ <= 10) {
                    axios.get(config.apiUrl() + 'member/certificate/' + this.hash).then(response => {
                        this.downloadLink = config.downloadUrl() + 'certs/' + this.hash + '.pdf';
                    }, err => {
                        setTimeout(() => {
                            this.checkCert();
                        }, 30000);
                    });
                }
            }
        },
        computed: {
            'doc_type': function() {
                if (this.type === 'cert') return 'Certificate';
                if (this.type === 'policy') return 'Policy'
            }
        },
        mounted() {
            this.checkCert();
        }
    }
</script>

<style scoped>

</style>
